<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card invoice p-0">
          <!-- Card header -->
          <div
            class="d-lg-flex justify-content-between align-items-center mx-2 pb-0 card-header invoice"
          >
            <h5>Permissions</h5>
            <!-- <div class="d-flex gap-3">
              <div class="flex-grow-1">
                <input
                  type="text"
                  v-model="searchQuery"
                  class="form-control invoice"
                  placeholder="Search..."
                />
              </div>
              <div class="">
                <button
                  @click="openAddForm"
                  class="bg-success btn text-white rounded py-0"
                  :style="{ height: '35px' }"
                >
                  Add New
                </button>
              </div>
            </div> -->
          </div>
          <div class="px-0 pb-0 card-body">
            <!-- Table -->
            <div class="table-responsive" v-if="users.length > 0">
              <div class="card mb-4">
                <div class="card-body px-0 pt-0 pb-2 invoice">
                  <div class="table-responsive p-0">
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <th class="text-sm">Name</th>
                          <!-- <th class="text-sm">Email</th>
                          <th class="text-sm">Contact</th> -->
                          <th class="text-sm">Role</th>
                          <th class="text-sm">Status</th>
                          <th class="text-sm">Permission</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in users" :key="index">
                          <td class="text-sm">{{ item?.user?.username }}</td>
                          <!-- <td class="text-sm">{{ item?.user?.email }}</td>
                          <td class="text-sm">{{ item.number }}</td> -->
                          <td class="text-sm">{{ item.user_role }}</td>
                          <td class="text-sm">
                            <span
                              :class="
                                item.status
                                  ? 'active-status'
                                  : 'inactive-status'
                              "
                            >
                              {{ item.status ? "Active" : "Inactive" }}
                            </span>
                          </td>
                          <td>
                            <div
                              class="d-flex align-items-center ml-4"
                              style="gap: 12px"
                            >
                              <template v-if="hasPermission('2023')">
                                <i
                                  @click="goToPermissions(item)"
                                  class="fas fa-arrow-right text-white cursor-pointer"
                                ></i>
                              </template>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <Skalaton />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Sliding Panel -->
    <div class="form-panel" :class="{ 'is-open': isFormPanelOpen }">
      <div class="form-header">
        <h5 v-if="isEditing">Edit User</h5>
        <h5 v-else>Add New User</h5>
        <span @click="toggleFormPanel" class="item">
          <Close />
        </span>
      </div>
      <form
        @submit.prevent="saveUser"
        class="d-flex flex-column"
        style="gap: 10px"
      >
        <div>
          <label class="form-label">Username</label>
          <input
            type="text"
            placeholder="Username"
            class="form-control invoice-card"
            v-model="form.user.username"
            required
          />
        </div>
        <div>
          <label class="form-label">Email</label>
          <input
            type="email"
            placeholder="Email"
            class="form-control invoice-card"
            v-model="form.user.email"
            required
          />
        </div>
        <div>
          <label class="form-label">Password</label>
          <input
            type="password"
            placeholder="Password"
            class="form-control invoice-card"
            v-model="form.user.password"
          />
        </div>
        <div>
          <label class="form-label">Contact Number</label>
          <input
            type="text"
            placeholder="Contact Number"
            class="form-control invoice-card"
            v-model="form.number"
          />
        </div>
        <div>
          <label class="form-label">Address</label>
          <input
            type="text"
            placeholder="Address"
            class="form-control invoice-card"
            v-model="form.address"
          />
        </div>
        <div>
          <label class="form-label">Branch</label>
          <input
            type="text"
            placeholder="ISP Name"
            class="form-control invoice-card"
            v-model="form.isp_name"
          />
        </div>
        <div>
          <label class="form-label">ISP Name</label>
          <input
            type="text"
            placeholder="ISP Name"
            class="form-control invoice-card"
            v-model="form.isp_name"
          />
        </div>
        <div>
          <label class="form-label">Role</label>
          <select class="form-control bg" v-model="form.user_role">
            <option value="Admin">Admin</option>
            <option value="User">User</option>
            <option value="Guest">Guest</option>
          </select>
        </div>
        <div>
          <label class="form-label">User Price</label>
          <input
            type="number"
            placeholder="User Price"
            class="form-control invoice-card"
            v-model="form.user_price"
          />
        </div>
        <div>
          <label class="form-label">Send Message</label>
          <input type="checkbox" class="mx-1 mt-1" v-model="form.send_msg" />
        </div>
        <div class="mt-4">
          <button type="submit" class="btn btn-success">
            {{ isEditing ? "Update" : "Save" }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Skalaton from "@/components/Skalaton.vue";
import Close from "../components/Icon/Close.vue";
import { useUserApi } from "../services/user.service";
import { hasPermission } from "@/utils/permissions.js";
import showSwal from "@/mixins/showSwal.js"; 

export default {
  name: "UserList",
  components: { Skalaton, Close },
  data() {
    return {
      users: [],
      searchQuery: "",
      isFormPanelOpen: false,
      isEditing: false,
      editingId: null,
      form: {
        user: {
          username: "",
          email: "",
          password: "",
        },
        number: "",
        address: "",
        isp_name: "",
        user_price: "",
        send_msg: false,
        user_role: "User",
      },
    };
  },
  async mounted() {
    this.getData();
  },
  methods: {
    hasPermission,
    goToPermissions(item) {
      if (!this.hasPermission("2024")) {
        showSwal.methods.showSwal({
          type: "error",
          message: "You do not have permission to perform this action.",
        });
        return;
      }
      this.$router.push({
        name: "Permissions",
        params: { id: item.fendy_user_id, user_id: item.id },
      });
    },
    async getData() {
      try {
        const response = await useUserApi().getUserData();
        this.users = response;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    toggleFormPanel() {
      this.isFormPanelOpen = !this.isFormPanelOpen;
    },
    openAddForm() {
      this.isEditing = false;
      this.resetForm();
      this.toggleFormPanel();
    },
    openEditForm(user) {
      this.isEditing = true;
      this.editingId = user.id;
      this.form = JSON.parse(JSON.stringify(user)); // Clone user data into form
      this.toggleFormPanel();
    },
    async saveUser() {
      try {
        if (this.isEditing) {
          // Update existing user
          await useUserApi().putUserData(this.form, this.editingId);
          this.getData();
          alert("User updated successfully!");
        } else {
          // Add new user
          const response = await useUserApi().postUserData(this.form);
          this.users.push(response);
          alert("User added successfully!");
        }
        this.resetForm();
        this.toggleFormPanel();
      } catch (error) {
        console.error("Error saving user:", error);
        alert("Failed to save user.");
      }
    },
    resetForm() {
      this.form = {
        user: {
          username: "",
          email: "",
          password: "",
        },
        number: "",
        address: "",
        isp_name: "",
        user_price: "",
        send_msg: false,
        user_role: "User",
      };
    },
    async deleteUser(index) {
      if (confirm("Are you sure you want to delete this user?")) {
        try {
          const userId = this.users[index]?.id;
          await useUserApi().deleteUserData(userId);
          this.users.splice(index, 1);
          alert("User deleted successfully!");
        } catch (error) {
          console.error("Error deleting user:", error);
          alert("Failed to delete user.");
        }
      }
    },
  },
};
</script>

<style>
td {
  padding: 12px 24px !important;
}

.active-status {
  background: green !important;
  color: white !important;
  padding: 0 5px;
  border-radius: 5px;
}
.dark-mode .active-status {
  color: white !important;
}
.dark-mode .inactive-status {
  color: white !important;
}
.inactive-status {
  background: red !important;
  color: white !important;
  padding: 0 5px;
  border-radius: 5px;
}

/* ===============panel---------- */
.form-panel {
  position: fixed;
  top: 0;
  right: -100%;
  height: 100%;
  width: 400px;
  background: #fff;
  transition: all 0.3s ease;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
  padding: 20px;
  z-index: 1050;
}
.dark-mode .form-panel {
  background-color: #061f3e !important;
}
.form-panel.is-open {
  right: 0;
}
.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dark-mode .bg {
  background-color: #061f3e !important;
  color: white;
}
</style>
